// @flow

import React from "react";

import { Shelf, Header, StepsWrapper, Stepper } from "./components";
import { Text } from "@src/common";

export default class extends React.Component {
  render() {
    return (
      <Shelf
        alignItems="flex-start"
        justifyContent="flex-start"
        flexDirection="column"
        padding="3"
        flex="1"
        boxShadow
      >
        <Header>
          <Text type="medium" size="3">
            Individual Client Risk Assessment Tool (ICRA)
          </Text>
        </Header>
        <StepsWrapper>
          <Stepper />
        </StepsWrapper>
      </Shelf>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Assessment/Sidebar/index.jsx